import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { getPersons, getTotalPrice } from '../../../states/offer/offer.selector';
import { first } from 'rxjs/operators';
import {
  PersonBasicInsuranceState,
  PersonState,
  PersonSupplementaryInsuranceState,
} from '../../../states/offer/offer.state';
import { withLatestFrom } from 'rxjs';
import { isNotNullOrUndefined } from '../../../utils/typeUtils';
import { legacyTrackingIds } from './tracking-legacy.map';
import { TrackingService } from '../tracking.service';
import { LEGACY_EVENT_TYPES } from './tracking-legacy.events';

@Injectable({
  providedIn: 'root',
})
export class TrackingLegacyService {
  constructor(private store: Store) {}

  public trackOrderOffer(isExistingCustomer: boolean): void {
    this.store
      .select(getPersons)
      .pipe(first(), withLatestFrom(this.store.select(getTotalPrice)))
      .subscribe(([persons, totalPrice]) => {
        const offerProducts = this.getOfferProducts(persons);

        TrackingService.trackEvent({
          event: LEGACY_EVENT_TYPES.OFFER_COMPLETE,
          offerType: 'quote',
          offerProducts,
          offerTotal: totalPrice,
          offerIsClient: isExistingCustomer,
        });
      });
  }

  public trackSubmission(): void {
    this.store
      .select(getPersons)
      .pipe(first(), withLatestFrom(this.store.select(getTotalPrice)))
      .subscribe(([persons, totalPrice]) => {
        const offerProducts = this.getOfferProducts(persons);

        TrackingService.trackEvent({
          event: LEGACY_EVENT_TYPES.OFFER_COMPLETE,
          offerType: 'closing',
          offerProducts,
          offerTotal: totalPrice,
          offerIsClient: undefined,
        });
      });
  }

  private static mapInsurances(
    basicInsurance: PersonBasicInsuranceState | undefined,
    supplementaryInsurances: PersonSupplementaryInsuranceState,
  ): string[] {
    const supplementaryInsuranceKeys = Object.entries(supplementaryInsurances)
      .filter(([_, insuranceValue]) => isNotNullOrUndefined(insuranceValue))
      .map(([insuranceKey]) => legacyTrackingIds[insuranceKey as keyof PersonSupplementaryInsuranceState]);

    if (basicInsurance) {
      return [legacyTrackingIds[basicInsurance.key.modelType], ...supplementaryInsuranceKeys];
    }
    return supplementaryInsuranceKeys;
  }

  public trackOfferUpdate(persons: PersonState[], totalPrice: number | undefined): void {
    const offerProducts = this.getOfferProducts(persons);

    TrackingService.trackEvent({
      event: LEGACY_EVENT_TYPES.OFFER_UPDATE,
      offerProducts,
      offerTotal: totalPrice,
    });
  }

  private getOfferProducts(persons: PersonState[]): string[] {
    return persons.flatMap((person) =>
      TrackingLegacyService.mapInsurances(person.basicInsurance, person.supplementaryInsurances),
    );
  }
}
